<template>
  <div>
    <div class="brand_infoBox text-center mt50">
      <h1 class="brand_logo"></h1>
    </div>
    <div class="fullbox">
      <div class="fullbox_cont text-center">
        <div class="form_writeVin">
          <div class="form-group" :class="{'has-error':inValidFrameNo || inValidFrameNoApi}">
            <label for="bike_vin">{{ $t('writeFrameNo.inputLabel') }}</label>
            <input type="text" class="form-control" id="bike_vin" placeholder="" v-model.trim.lazy="strFrameNo" autocomplete="off" @keyup.enter="applyBtnDisable || funcCheckLength()" :disabled="applyBtnDisable">
            <p class="help-block" v-if ="inValidFrameNo">{{ $t('writeFrameNo.errMessage') }}</p>
            <p class="help-block" v-if ="inValidFrameNoApi">{{ $t('writeFrameNo.errMessageValidatError') }}</p>
          </div>
          <div class="text-center">
            <button type="button" class="btn btn_normalBtn" @click="funcBackToHome()" :disabled="applyBtnDisable">{{ $t('writeFrameNo.btnBack') }}</button>
            <button type="button" class="btn btn_normalBtn" @click="funcCheckLength()" :disabled="applyBtnDisable">{{ $t('writeFrameNo.btnEnter') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { funcWebViewHeight } from '@/utils/web-style/web-style';
import { funcEncryptData, funcDecryptData } from '@/utils/crypt';
import * as connectBikeAPI from '@/api/connect-bike';

export default {
  name: 'WriteFramenumber',
  data () {
    return {
      strFrameNo: '',
      regulation_25km: /^EF[A-Z][\d]{7}$/,
      regRD11S: /^XN[A-Z]RD11S[A-Z][^I0-9a-z][^I0-9a-z][\d]{6}$/,
      regRD10S: /^XN[A-Z]RD10S[A-Z][^I0-9a-z][^I0-9a-z][\d]{6}$/,
      regMA11S: /^XN[A-Z]MA11S[A-Z][^I0-9a-z][^I0-9a-z][\d]{6}$/,
      regMD11S: /^XN[A-Z]MD11S[A-Z][^I0-9a-z][^I0-9a-z][\d]{6}$/,
      inValidFrameNo: false,
      inValidFrameNoApi: false,
      applyBtnDisable: false
    };
  },
  mounted () {
    // 高度偵測
    funcWebViewHeight();
  },
  methods: {
    funcBackToHome () {
      this.$router.push({ name: 'Home' });
    },
    funcCheckLength () {
      this.applyBtnDisable = true; // disable btn
      let regFrame = false;
      if (this.strFrameNo.length === 10) {
        regFrame = this.frameNoReg(['regulation_25km']);
      } else if (this.strFrameNo.length === 17) {
        regFrame = this.frameNoReg('regRD11S', 'regRD10S', 'regMA11S', 'regMD11S');
      }

      if (regFrame) {
        this.funcCheckFrameNoInvalid();
      }
      else {
        this.applyBtnDisable = false; // reset disable
        this.inValidFrameNoApi = false;
        this.inValidFrameNo = true;
      }
    },
    /**
     * @param {Array} regulations
     * @return {Boolean}
     */
    frameNoReg (regulations) {
      const regResult = regulations.map(reg => {
        return this[reg].test(this.strFrameNo);
      })
      return regResult.every(res => res);
    },
    async funcCheckFrameNoInvalid () {
      let bikeFID = { FrameNo: this.strFrameNo };
      const encryptData = funcEncryptData(bikeFID);
      const { ErrorCode, InvalidFrame } = await connectBikeAPI.checkInvalidFrame(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      console.log("TCL: checkInvalidFrame -> data", { ErrorCode, InvalidFrame });
      this.applyBtnDisable = false;
      if (ErrorCode === 0) {
        this.inValidFrameNoApi = InvalidFrame;
        if (!this.inValidFrameNoApi) {
          // 確認 api 有此 vin 才進入 vinrecheck
          this.fucnGoToVINpage();
        }
        else {
          this.inValidFrameNo = false;
        }
      }
      else {
        this.$store.dispatch('bikeConnect/setConnFail', '[B01] ' + ErrorCode);
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
      }
    },
    fucnGoToVINpage () {
      this.inValidFrameNo = false;
      this.$store.dispatch('bikeConnect/setBikeFrameNo', this.strFrameNo);
      this.$router.push('/vinrecheck');
    }
  }
};
</script>

<style lang="scss" scoped>
.fullbox_cont {
  @include pc-width {
    width: 580px;
  }
}

.form_writeVin {
  label {
    margin-bottom: 50px;
  }

  .btn_normalBtn {
    margin-top: 30%;
    margin-right: 10%;
  }
}

.has-error {
  .help-block {
    color: $red;
  }
  .form-control {
    border-color: $red;
  }
}
</style>
